import React from "react";
import { Modal } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
import { Button } from "react-bootstrap";

export default function Filter(props) {
  const { onHide, show, filterInputsUpdate, filterInputs,setFilterInputs } = props;

  const onResetFilter = () => {
    setFilterInputs({
     
      pin: "",
      
    });
    
    onHide(false)
  }

  return (
    <Modal
      size="md"
      show={show}
      onHide={onHide}
      aria-labelledby="create"
      centered
      className="modal pr-0"
    >
      <Modal.Header closeButton>
        <Modal.Title id="create">Qurğudakı Əməkdaşlar filtri</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 pl-4 pr-4">
          <div className="row">
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                   id="pin"
                   name="pin"
                   label="Fin kod"
                   placeholder="Fin kod"
                  className="w-100"
                  value={filterInputs.pin}
                  onChange={(e) =>
                    filterInputsUpdate("pin", e.target.value)
                  }
                />
              </div>
            </div>
          
          </div>
          <div className="d-flex justify-content-end">  <Button
          variant="primary"
          onClick={() => {
            onResetFilter();
          }}
          className="mt-4"
        >
         Sıfırla
        </Button>
        <Button
          variant="success"
          onClick={() => {
            onHide(false);
          }}
          className="mt-4 ml-4"
        >
         Tamam
        </Button></div>
        
        </div>
      </Modal.Body>
    </Modal>
  );
}
